import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.prototype3');
import { OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-prototype3',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.prototype3/view.scss */
:host {
  display: block;
  height: 100%;
}

button {
  transition: background-color 120ms ease, color 120ms ease, border-color 120ms ease;
}

table {
  border-collapse: collapse;
}`],
})
export class PagePrototype3Component implements OnInit, OnDestroy {
    @ViewChild('videoElement') videoElement: ElementRef<HTMLVideoElement>;
    @ViewChild('canvasElement') canvasElement: ElementRef<HTMLCanvasElement>;

    public isCameraOn: boolean = false;
    public fpsMode: number = 1;
    public finalState: string = "대기 중";
    public risk: string = "-";
    public riskScore: number = 0;
    public inferMs: number = 0;
    public currentEmotion: string = "-";
    public behavior: any = null;
    public pose: any = null;
    public gaze: any = null;
    public motion: any = null;
    public quality: any = null;
    public window: any = null;
    public reasons: string[] = [];
    public ruleScores: any = {};
    public historyQueue: any[] = [];
    public observationLog: any[] = [];
    public meta: any = null;
    public isExperimentPopupOpen: boolean = false;

    private stream: MediaStream | null = null;
    private captureInterval: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public async ngOnDestroy() {
        this.stopCamera();
    }

    public async startCamera() {
        try {
            this.stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
            this.videoElement.nativeElement.srcObject = this.stream;
            this.isCameraOn = true;

            this.videoElement.nativeElement.onloadedmetadata = () => {
                this.syncCanvasSize();
                this.startAnalysis();
            };

            await this.service.render();
        } catch (err) {
            console.error(err);
            await this.service.alert.show({ title: '오류', message: '카메라 접근 실패' });
        }
    }

    public async stopCamera() {
        if (this.stream) {
            this.stream.getTracks().forEach(track => track.stop());
            this.stream = null;
        }
        if (this.captureInterval) {
            clearInterval(this.captureInterval);
            this.captureInterval = null;
        }
        if (this.videoElement) this.videoElement.nativeElement.srcObject = null;
        if (this.canvasElement) {
            const ctx = this.canvasElement.nativeElement.getContext('2d');
            if (ctx) ctx.clearRect(0, 0, this.canvasElement.nativeElement.width, this.canvasElement.nativeElement.height);
        }

        this.isCameraOn = false;
        this.finalState = "대기 중";
        this.risk = "-";
        this.riskScore = 0;
        this.historyQueue = [];
        this.observationLog = [];
        await this.service.render();
    }

    public async setFpsMode(value: number) {
        this.fpsMode = value;
        if (this.isCameraOn) this.startAnalysis();
        await this.service.render();
    }

    public async openExperimentPopup() {
        this.isExperimentPopupOpen = true;
        await this.service.render();
    }

    public async closeExperimentPopup() {
        this.isExperimentPopupOpen = false;
        await this.service.render();
    }

    private startAnalysis() {
        if (this.captureInterval) clearInterval(this.captureInterval);
        const intervalMs = this.fpsMode === 3 ? 333 : 1000;
        this.captureInterval = setInterval(() => {
            this.captureAndPredict();
        }, intervalMs);
    }

    private async captureAndPredict() {
        const video = this.videoElement.nativeElement;
        if (!video || video.videoWidth === 0 || video.videoHeight === 0) return;

        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataUrl = canvas.toDataURL('image/jpeg', 0.82);

        try {
            const resultInfo = await wiz.call("predict", {
                image: dataUrl,
                history: JSON.stringify(this.historyQueue)
            });

            if (resultInfo.code === 200 && resultInfo.data.status === "success") {
                const result = resultInfo.data;
                this.meta = result.meta;
                this.finalState = result.final_state;
                this.risk = result.risk;
                this.riskScore = result.risk_score;
                this.currentEmotion = result.emotion;
                this.behavior = result.behavior;
                this.pose = result.pose;
                this.gaze = result.gaze;
                this.motion = result.motion;
                this.quality = result.quality;
                this.window = result.window;
                this.reasons = result.reasons || [];
                this.ruleScores = result.rule_scores || {};
                this.inferMs = result.infer_ms || 0;
                this.historyQueue = result.history || [];

                this.observationLog.unshift({
                    time: new Date().toLocaleTimeString(),
                    state: this.finalState,
                    risk: this.risk,
                    ear: this.behavior?.ear,
                    yaw: this.pose?.yaw,
                    pitch: this.pose?.pitch,
                    roll: this.pose?.roll,
                    gaze: this.gaze?.direction,
                    quality: this.quality?.score
                });
                if (this.observationLog.length > 30) this.observationLog.pop();
                this.drawOverlay(result.region, result.frame);
            } else {
                this.finalState = resultInfo.data.final_state || "Unknown / Low Confidence";
                this.risk = resultInfo.data.risk || "Unknown";
                this.reasons = resultInfo.data.reasons || [resultInfo.data.message || "분석 실패"];
                this.drawOverlay(null, null);
            }
        } catch (e) {
            console.error("Predict Exception:", e);
        }
        await this.service.render();
    }

    private syncCanvasSize() {
        const canvas = this.canvasElement.nativeElement;
        const video = this.videoElement.nativeElement;
        if (canvas.width !== video.clientWidth || canvas.height !== video.clientHeight) {
            canvas.width = video.clientWidth;
            canvas.height = video.clientHeight;
        }
    }

    private drawOverlay(region: any, frame: any) {
        const canvas = this.canvasElement.nativeElement;
        const video = this.videoElement.nativeElement;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        this.syncCanvasSize();
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (!region || !frame) return;

        const frameW = frame.width || video.videoWidth;
        const frameH = frame.height || video.videoHeight;
        const videoRatio = frameW / frameH;
        const containerRatio = canvas.width / canvas.height;
        let drawWidth = 0;
        let drawHeight = 0;
        let offsetX = 0;
        let offsetY = 0;

        if (containerRatio > videoRatio) {
            drawWidth = canvas.width;
            drawHeight = canvas.width / videoRatio;
            offsetY = (canvas.height - drawHeight) / 2;
        } else {
            drawHeight = canvas.height;
            drawWidth = canvas.height * videoRatio;
            offsetX = (canvas.width - drawWidth) / 2;
        }

        const scaleX = drawWidth / frameW;
        const scaleY = drawHeight / frameH;
        const x = region.x * scaleX + offsetX;
        const y = region.y * scaleY + offsetY;
        const w = region.w * scaleX;
        const h = region.h * scaleY;
        const color = this.risk === "위험" ? "#ef4444" : this.risk === "주의" ? "#f59e0b" : "#10b981";

        ctx.strokeStyle = color;
        ctx.lineWidth = 3;
        ctx.strokeRect(x, y, w, h);
        ctx.fillStyle = color;
        ctx.fillRect(x, Math.max(0, y - 28), Math.min(360, Math.max(210, w)), 26);
        ctx.fillStyle = "#ffffff";
        ctx.font = "bold 13px sans-serif";
        ctx.fillText(`${this.finalState} / ${this.risk}`, x + 8, Math.max(18, y - 10));
    }

    public fmt(value: any, digits: number = 2) {
        if (value === null || value === undefined || isNaN(value)) return "-";
        return Number(value).toFixed(digits);
    }
}

export default PagePrototype3Component;